export const CHECKOUT_STEPS = {
  DISPLAY_PLANS: 0,
  BUILD_PLAN: 1,
  PAYMENT_METHOD: 2,
  CHECKOUT_STATUS: 3,
};

export const BUTTON_ACTIONS = {
  UPGRADE: 'upgrade',
  CURRENT_PLAN: 'current_plan',
  DEFAULT: 'default',
  DOWNGRADE: 'downgrade',
  CHANGE_VOLUME: 'change_volume',
  CONTACT_US: 'contact_us',
};
